// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__9JGpW","time":"styles_time__3l3sH"};